export const ALL_HORIZON_REGIONS = 'Both' as const;
export const ALL_TRIGGERED_BY = 'All' as const;

export type HorizonRegion = 'US' | 'UK';
export type HorizonOptOutType = 'Worth' | 'Worth unavailable' | 'Global Payments';
export type HorizonRecordFlag = 'Disqualified' | 'Opted out' | 'Disqualified and opted out' | 'Unknown';
export type HorizonTriggeredByFilter = typeof ALL_TRIGGERED_BY | 'Worth' | 'Non-Worth';
export type HorizonTimeZone = 'UTC' | 'Local';

/** A Horizon configuration supported by the opt-out tracker. */
export interface HorizonConfig {
  id: number;
  name: 'Horizon_US' | 'Horizon_UK';
  region: HorizonRegion;
}

/** The IngestApp fields required to build an opt-out tracker row. */
export interface HorizonIngestApp {
  appUid: string;
  companyName: string;
  email: string;
  isDisqualified: boolean;
  isOptedOut: boolean;
  region: HorizonConfig['region'];
}

/** A normalized EventLog candidate for an opt-out. */
export interface HorizonEventLog {
  appUid: string;
  eventDateUTC: string;
  eventType: string;
  eventDescription: string;
}

/** Opt-out details progressively loaded for one Horizon application. */
export interface HorizonOptOutDetails {
  optOutReason: string;
  optOutTimeUTC: string;
  type: HorizonOptOutType;
}

/** Calendar-date bounds used to filter Horizon opt-out events. */
export interface HorizonOptOutDateRange {
  endDate: string;
  startDate: string;
}

export type HorizonRegionFilter = typeof ALL_HORIZON_REGIONS | HorizonRegion;

type HorizonOptOutDetailStatus = 'loading' | 'loaded' | 'unresolved' | 'error';

/** A disqualified IngestApp with progressively loaded opt-out details. */
export interface HorizonOptOutDisplayRow extends HorizonIngestApp {
  detailStatus: HorizonOptOutDetailStatus;
  optOutReason?: string;
  optOutTimeUTC?: string;
  type?: HorizonOptOutDetails['type'];
}
